import { IExpression } from "../IExpression";

export type NotifyExpression = IExpression & {
    Message: string;
    Severity?: NotifySeverity;
};

export enum NotifySeverity {
    Success = "Success",
    Error = "Error",
    Info = "Info"
}